(function () {
  'use strict';

  var COLUMN_SEL = '.wpb_column, .vc_column_container';
  var PIN_MIN_WIDTH = 768;

  function slugify(text) {
    var s = (text || '').toLowerCase().trim();
    s = s.replace(/[^\w\s-]/g, '');
    s = s.replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
    return s || 'section';
  }

  function ensureIds(headings) {
    var used = {};
    headings.forEach(function (h, i) {
      var base = h.id && h.id.trim() ? h.id.trim() : slugify(h.textContent || '') + '-' + (i + 1);
      var id = base;
      var suffix = 0;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) {
        suffix += 1;
        id = base + '-' + suffix;
      }
      used[id] = true;
      h.id = id;
    });
  }

  function findContentColumn(tocRoot) {
    var col = tocRoot.closest(COLUMN_SEL);
    if (!col) return null;
    var next = col.nextElementSibling;
    while (next && !next.matches(COLUMN_SEL)) {
      next = next.nextElementSibling;
    }
    return next;
  }

  /** WPBakery row (ancestor of column). */
  function findWpbRow(el) {
    var p = el;
    while (p) {
      if (p.classList && (p.classList.contains('wpb_row') || p.classList.contains('vc_row'))) {
        return p;
      }
      p = p.parentElement;
    }
    return null;
  }

  function resetRowPin(inner, outer) {
    if (!inner || !outer) return;
    inner.classList.remove('section_toc__pin--fixed');
    inner.style.removeProperty('position');
    inner.style.removeProperty('top');
    inner.style.removeProperty('left');
    inner.style.removeProperty('width');
    inner.style.removeProperty('box-sizing');
    outer.style.removeProperty('min-height');
  }

  /**
   * Fixed-position pin within the row’s vertical span (viewport coordinates).
   * Avoids CSS sticky, which breaks under many WPBakery row wrappers.
   * @param pinEndMargin — rows bottom is treated as rowRect.bottom minus this (px), so the
   *   bar stops following the viewport that much before the section ends.
   */
  function updateRowPin(outer, inner, topOffset, pinEndMargin) {
    if (!outer || !inner) return;
    if (window.innerWidth < PIN_MIN_WIDTH) {
      resetRowPin(inner, outer);
      return;
    }

    var row = findWpbRow(outer);
    if (!row) {
      resetRowPin(inner, outer);
      return;
    }

    var rowRect = row.getBoundingClientRect();
    var outerRect = outer.getBoundingClientRect();
    var h = inner.offsetHeight;
    if (h < 1) return;

    if (outerRect.top > topOffset) {
      resetRowPin(inner, outer);
      return;
    }

    var margin =
      typeof pinEndMargin === 'number' && !isNaN(pinEndMargin) && pinEndMargin > 0 ? pinEndMargin : 0;
    var rowEffectiveBottom = rowRect.bottom - margin;
    var maxTop = rowEffectiveBottom - h;
    // No vertical space left inside the row (section scrolled above / nearly gone): unpin instead
    // of clamping top to 0, which would leave the TOC fixed to the viewport.
    if (maxTop < 0) {
      resetRowPin(inner, outer);
      return;
    }

    var topPx = Math.min(topOffset, maxTop);

    inner.classList.add('section_toc__pin--fixed');
    inner.style.position = 'fixed';
    inner.style.top = topPx + 'px';
    inner.style.left = outerRect.left + 'px';
    inner.style.width = outerRect.width + 'px';
    inner.style.boxSizing = 'border-box';

    outer.style.minHeight = h + 'px';
  }
  

  function setActive(links, activeId) {
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var id = href.charAt(0) === '#' ? href.slice(1) : '';
      var on = id === activeId;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  function visibleHeightInBand(rect, bandTop, bandBottom) {
    var top = Math.max(rect.top, bandTop);
    var bottom = Math.min(rect.bottom, bandBottom);
    return Math.max(0, bottom - top);
  }

  /** Section = parent WPB row for each H3 (content lives in that row). */
  function rowRectForHeading(h3) {
    var row = findWpbRow(h3);
    return row ? row.getBoundingClientRect() : h3.getBoundingClientRect();
  }

  /**
   * Sections with ≥50% of their row in the visible band (below header inset) qualify.
   * If several qualify (e.g. previous + next both on screen), keep the earliest in document
   * order so the highlight doesn’t jump ahead while the previous section is still majority-visible.
   */
  function updateActiveMajority(headings, links, bandTop, bandBottom) {
    if (!headings.length) return;

    var scored = headings.map(function (h, index) {
      var rect = rowRectForHeading(h);
      var hgt = rect.height;
      if (hgt < 1) hgt = 1;
      var vis = visibleHeightInBand(rect, bandTop, bandBottom);
      var ratio = vis / hgt;
      return { id: h.id, index: index, ratio: ratio, visible: vis, majority: ratio >= 0.5 };
    });

    var majorityOnly = scored.filter(function (s) {
      return s.majority;
    });

    var anyVisible = false;
    for (var i = 0; i < scored.length; i++) {
      if (scored[i].visible > 0) {
        anyVisible = true;
        break;
      }
    }

    if (!anyVisible && scored.length) {
      var mid = (bandTop + bandBottom) / 2;
      var bestId = scored[0].id;
      var bestDist = Infinity;
      scored.forEach(function (s, idx) {
        var rect = rowRectForHeading(headings[idx]);
        var cy = (rect.top + rect.bottom) / 2;
        var d = Math.abs(cy - mid);
        if (d < bestDist) {
          bestDist = d;
          bestId = s.id;
        }
      });
      setActive(links, bestId);
      return;
    }

    if (majorityOnly.length) {
      var earliest = majorityOnly[0];
      for (var m = 1; m < majorityOnly.length; m++) {
        if (majorityOnly[m].index < earliest.index) earliest = majorityOnly[m];
      }
      setActive(links, earliest.id);
      return;
    }

    // No majority: pick strongest partial overlap; tie → earlier section, then more pixels.
    var pool = scored;
    var best = pool[0];
    for (var j = 1; j < pool.length; j++) {
      var c = pool[j];
      if (c.ratio > best.ratio + 1e-6) best = c;
      else if (Math.abs(c.ratio - best.ratio) <= 1e-6 && c.index < best.index) best = c;
    }
    setActive(links, best.id);
  }

  function initNav(nav) {
    var list = nav.querySelector('.section_toc__list');
    if (!list) return;

    var contentCol = findContentColumn(nav);
    if (!contentCol) return;

    var headings = [].slice.call(contentCol.querySelectorAll('h3'));
    if (!headings.length) return;

    ensureIds(headings);

    list.innerHTML = '';
    headings.forEach(function (h) {
      var li = document.createElement('li');
      li.className = 'section_toc__item';

      var a = document.createElement('a');
      a.className = 'section_toc__link';
      a.href = '#' + h.id;

      var p = document.createElement('p');
      p.textContent = (h.textContent || '').replace(/\s+/g, ' ').trim();

      a.appendChild(p);
      li.appendChild(a);
      list.appendChild(li);

      a.addEventListener('click', function (e) {
        e.preventDefault();
        var el = document.getElementById(h.id);
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#' + h.id);
        }
      });
    });

    var links = [].slice.call(list.querySelectorAll('.section_toc__link'));
    var stickyTop = parseInt(nav.getAttribute('data-sticky-top'), 10);
    if (isNaN(stickyTop)) stickyTop = 60;
    var viewportInset = parseInt(nav.getAttribute('data-scroll-offset'), 10);
    if (isNaN(viewportInset)) viewportInset = 60;
    var pinEndMargin = parseInt(nav.getAttribute('data-pin-end-margin'), 10);
    if (isNaN(pinEndMargin)) pinEndMargin = 100;

    var outer = nav.closest('.section_toc__sticky');
    var inner = nav.closest('.section_toc__pin');

    var ticking = false;
    var tick = function () {
      var bandBottom = window.innerHeight;
      updateActiveMajority(headings, links, viewportInset, bandBottom);
      if (outer && inner) updateRowPin(outer, inner, stickyTop, pinEndMargin);
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        tick();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    if (typeof ResizeObserver !== 'undefined' && inner) {
      var ro = new ResizeObserver(onScroll);
      ro.observe(inner);
    }

    window.addEventListener('load', onScroll, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('[data-section-toc]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
